import { createGlobalStyle } from "styled-components";

import "./assets/images/fonts/GothamPro/gotham.css";

export default createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    html{
         scroll-behavior: smooth;
    }

    ul, h1, span, p, label, a, textarea, input{
       font-family: "GothamPro", sans-serif;
    }

    p{
        font-weight: 100;
        font-size: 21px;
    }

    @media(max-width: 425px){
        p{
            font-size: 16px;
        }
    }
 
`;
